import store from '../store'

export default function (to, from, next) {
    if (
        Object.keys(store.getters['user/authenticated']).length
        || Object.keys(to.query).includes('access_token')
    ) {
        next()
    } else {
        store.dispatch('route/setPreviousUrl', to)
        next({ name: 'Login' })
    }
}
